import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dna, Binary, Atom, HeartPulse, Activity, Users2, Layers, Stethoscope } from "lucide-react";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";

const ITEMS = [
  { k: "c1", Icon: Dna },
  { k: "c2", Icon: Binary },
  { k: "c3", Icon: Atom },
  { k: "c4", Icon: HeartPulse },
  { k: "c5", Icon: Activity },
  { k: "c6", Icon: Users2 },
  { k: "c7", Icon: Layers },
  { k: "c8", Icon: Stethoscope },
];

export default function Communities() {
  const { t } = useTranslation();
  return (
    <section className="surface-2 py-20 lg:py-24 border-y border-line" data-testid="home-communities">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <SectionHead kicker={t("home.communities.kicker")} title={t("home.communities.title")} to="/house-of-wisdom" linkLabel={t("common.viewAll")} />
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 lg:gap-4">
          {ITEMS.map(({ k, Icon }, i) => (
            <Reveal key={k} delay={i * 0.05}>
              <Link
                to="/house-of-wisdom"
                data-testid={`home-community-${k}`}
                className="group flex flex-col items-center text-center gap-3 p-4 rounded-xl bg-white border border-line hover:border-gold/60 hover:-translate-y-1 transition-all duration-300 h-full"
              >
                <span className="icon-tile !h-11 !w-11"><Icon className="h-4.5 w-4.5" /></span>
                <span className="text-xs font-semibold text-ink leading-tight">{t(`home.communities.${k}`)}</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
